<template>
  <v-layout>
    <span v-if="getCountdown > 0 && !startedTimer">{{prepareTimer()}}</span>
        <v-flex xs10 v-if="getCountdown > 0">
          <v-progress-linear style="margin-top:8px"
            :background-opacity="0.3"
            :buffer-value="100"
            :rounded="true"
            :height="25"
            :value="getCountdown/18"
            color="light-blue"
          >{{Math.floor(getCountdown/60)}}:{{getCountdown % 60}}
          </v-progress-linear>
        </v-flex>
        <v-flex xs2 v-if="getCountdown > 0">
          <v-btn small style="margin:5px" @click="countDownRefresh()">Refresh</v-btn>
        </v-flex>

  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      startedTimer: false,
      timer : null
    }
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer); 
      this.timer = null;
      this.startedTimer = false
    }
  },
  computed: 
    mapGetters([
                'getCountdown',
                'isAdmin'
            ])
  ,
  methods: {
    prepareTimer() { 
      if (this.startedTimer) return
      this.startedTimer = true

      this.timer = setInterval(() => { if(this.getCountdown <= 0) {
          clearInterval(this.timer); 
          this.timer = null;
          this.startedTimer = false
      } else {
          this.$store.commit('downCountdown')
          }
      }, 1000);
    },
    countDownRefresh() {
        this.$store.dispatch('setCountDownRefresh')
    }
  }
  
}
</script>

<style>

</style>